import { defineProperty as _defineProperty } from '../../../_virtual/_rollupPluginBabelHelpers.js';

var classes = {
  /* Styles applied to the root element. */
  root: {
    overflow: 'hidden',
    WebkitOverflowScrolling: 'touch',
    // Add iOS momentum scrolling.
    display: 'flex'
  },
  /* Styles applied to the root element if `orientation="vertical"`. */
  vertical: {
    flexDirection: 'column',
    height: '100%'
  },
  /* Styles applied to the flex container element if `centered={true}` & `!mode="scrollable"`. */
  centered: {
    justifyContent: 'center'
  },
  /* Styles applied to the tablist element. */
  scroller: {
    position: 'relative',
    display: 'inline-block',
    flex: '1 1 auto',
    whiteSpace: 'nowrap'
  },
  /* Styles applied to the tablist element if `!mode="scrollable"`. */
  fixed: {
    overflow: 'hidden',
    width: '100%'
  },
  /* Styles applied to the tablist element if `mode="scrollable"`. */
  scrollable: {
    // Hide dimensionless scrollbar on MacOS
    scrollbarWidth: 'none',
    // Firefox
    '&::-webkit-scrollbar': {
      display: 'none' // Safari + Chrome
    }
  },
  scrollableHorizontal: {
    overflowY: 'hidden',
    overflowX: 'scroll'
  },
  scrollableVertical: {
    overflowY: 'scroll',
    overflowX: 'hidden'
  },
  /* Styles applied to the `ScrollButtonComponent` component if `scrollButtons="auto"` or scrollButtons="desktop"`. */
  scrollButtonsDesktop: function scrollButtonsDesktop(breakpoints, size) {
    return size ? _defineProperty({}, breakpoints.down(size), {
      display: 'none'
    }) : {};
  },
  /* Styles applied to the `TabIndicator` component. */
  indicator: {},
  /* Styles applied only to Vertical Nav Wrapper with Heading component. */
  verticalNavTabsWrapper: {
    paddingTop: '32px',
    paddingBottom: '32px',
    paddingRight: '32px',
    minWidth: '320px',
    maxWidth: '320px',
    backgroundColor: '#f2f3f4',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    borderRight: '1px solid #d9dbde'
  }
};

export { classes };
//# sourceMappingURL=classes.esm.js.map
